export default __webpack_public_path__ + "static/media/shopping-cart.5b518b58.png";